import { MatchCreatePage } from "@/features/match/pages/MatchCreate";
import React from "react";

const MatchCreate = () => {
  return <MatchCreatePage />;
};

export default MatchCreate;
